var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconDiamond2Xbft3L9Gq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef9d3a;}.cls-2{fill:#dd8628;}.cls-3{fill:#ffbc5a;}.cls-4{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Diamond") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DIamond"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,2H11.8907a2,2,0,0,0-1.4866.6621L2,12H15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,2h9.1093a2,2,0,0,1,1.4866.6621L46,12H33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.5959,2.662A2,2,0,0,0,36.1093,2h-3a2,2,0,0,1,1.4866.662L43,12h3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33 12 15 12 21 2 27 2 33 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24 46 33 12 46 12 24 46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43 12 26.077 38.154 24 46 46 12 43 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24 46 2 12 15 12 24 46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24 46 15 12 33 12 24 46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.9912,12.087a.8687.8687,0,0,0-.0607-.4289.9764.9764,0,0,0-.0406-.1071c-.0047-.0094-.006-.02-.011-.0291a.9813.9813,0,0,0-.0892-.1212c-.017-.0225-.0274-.0485-.0466-.07L38.3389,1.9937A3.0014,3.0014,0,0,0,36.1094,1H11.8906a3.0027,3.0027,0,0,0-2.2295.9932L1.2568,11.3311c-.019.0211-.0294.0471-.0464.07a.9852.9852,0,0,0-.0894.1214c-.0051.0093-.0063.02-.0111.0293a.9782.9782,0,0,0-.04.1062.9935.9935,0,0,0-.0479.1552,1.071,1.071,0,0,0,.0517.5464c.006.0156.0065.0323.0134.0477.0091.02.0247.0359.035.0555.014.0267.0216.0557.0382.0812l22,34a1.0007,1.0007,0,0,0,1.68,0l22-34c.0165-.0256.0241-.0545.0381-.0812.01-.02.026-.0351.0351-.0555.0069-.0154.0074-.0322.0135-.0478a1.3513,1.3513,0,0,0,.0646-.272ZM36.8525,3.3311,43.7549,11H33.5662l-4.8-8h7.3431A1.0008,1.0008,0,0,1,36.8525,3.3311ZM16.2988,13H31.7012L24,42.0923ZM26.4336,3l4.8,8H16.7666l4.8-8Zm-15.2861.3306A1.0022,1.0022,0,0,1,11.8906,3h7.3431l-4.8,8H4.2451ZM14.23,13l7.194,27.1784L3.8379,13ZM26.5748,40.18,33.77,13H44.1621Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconDiamond2Xbft3L9Gq);
export default __webpack_public_path__ + "static/media/reshot-icon-diamond-2XBFT3L9GQ.c51015c33c8fa0b2d6abd34e74b91f96.svg";
export { ForwardRef as ReactComponent };